import React from "react";
import { Container, BackgroundContainer } from "./styled";

const Loader = () => {
  return (
    <>
      <Container id="SuccessPopUp">
        <h1>Cargando...</h1>
        <iframe src="https://lottie.host/embed/8b06c342-d3f3-4d38-8fc4-cdef020eccd2/cJz4qYvfv0.lottie"></iframe>
      </Container>
      <BackgroundContainer />
    </>
  );
};

export default Loader;
